import { Injectable } from '@angular/core';
import { MenuGLSetup, MenuGLInput, MenuGLProcess, MenuGLReport, MenuGLInquiry,
    MenuAPSetup, MenuAPInput, MenuAPProcess, MenuAPReport, MenuAPInquiry,
    MenuARSetup, MenuARInput, MenuARProcess, MenuARReport, MenuARInquiry,
    MenuCASetup, MenuCAInput, MenuCAProcess, MenuCAReport, MenuCAInquiry,
    MenuFASetup, MenuFAInput, MenuFAProcess, MenuFAReport, MenuFAInquiry,
    MenuINSetup, MenuINInput, MenuINProcess, MenuINReport,
    MenuSASetup, MenuSAInput, MenuSAReport,MenuSTSetup,MenuSTSecurity,
    MenuSOInput, MenuSOProcess, MenuSOReport,MenuSIInput,MenuUFInput ,
    MenuPOInput, MenuPOProcess, MenuPOReport , MenuEISetup, MenuEIInput, MenuEIProcess, MenuBGInput, MenuBGReport, MenuCPFinancialStatement,
    MenuSPInput, MenuSPReport, MenuCPCustomers, MenuCPVendors, MenuCPRevenues, MenuCPCost, MenuCPAnalyze, MenuCPManagements, MenuCPHumanResources
    } from '../models/Other/menu.model';

@Injectable()
/**
 * menu data service
 */
export class MenuDataService {

    // Get Menu GL
    getMenuGLSetup(AccessFoGL: string[]) {
        return MenuGLSetup.filter(function (number) {
            return AccessFoGL.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuGLInput(AccessFoGL: string[]) {
        return MenuGLInput.filter(function (number) {
            return AccessFoGL.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuGLProcess(AccessFoGL: string[]) {
        return MenuGLProcess.filter(function (number) {
            return AccessFoGL.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuGLInquiry(AccessFoGL: string[]) {
        return MenuGLInquiry.filter(function (number) {
            return AccessFoGL.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuGLReport(AccessFoGL: string[]) {
        return MenuGLReport.filter(function (number) {
            return AccessFoGL.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu AP
    getMenuAPSetup(AccessFoAP: string[]) {
        return MenuAPSetup.filter(function (number) {
            return AccessFoAP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuAPInput(AccessFoAP: string[]) {
        return MenuAPInput.filter(function (number) {
            return AccessFoAP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuAPProcess(AccessFoAP: string[]) {
        return MenuAPProcess.filter(function (number) {
            return AccessFoAP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuAPInquiry(AccessFoAP: string[]) {
        return MenuAPInquiry.filter(function (number) {
            return AccessFoAP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuAPReport(AccessFoAP: string[]) {
        return MenuAPReport.filter(function (number) {
            return AccessFoAP.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu AR
    getMenuARSetup(AccessFoAR: string[]) {
        return MenuARSetup.filter(function (number) {
            return AccessFoAR.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuARInput(AccessFoAR: string[]) {
        return MenuARInput.filter(function (number) {
            return AccessFoAR.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuARProcess(AccessFoAR: string[]) {
        return MenuARProcess.filter(function (number) {
            return AccessFoAR.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuARInquiry(AccessFoAR: string[]) {
        return MenuARInquiry.filter(function (number) {
            return AccessFoAR.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuARReport(AccessFoAR: string[]) {
        return MenuARReport.filter(function (number) {
            return AccessFoAR.indexOf(number.RouterLink) > -1;
        });
    }
    
    // Get Menu CA
    getMenuCASetup(AccessFoCA: string[]) {
        return MenuCASetup.filter(function (number) {
            return AccessFoCA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCAInput(AccessFoCA: string[]) {
        return MenuCAInput.filter(function (number) {
            return AccessFoCA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCAProcess(AccessFoCA: string[]) {
        return MenuCAProcess.filter(function (number) {
            return AccessFoCA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCAInquiry(AccessFoCA: string[]) {
        return MenuCAInquiry.filter(function (number) {
            return AccessFoCA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCAReport(AccessFoCA: string[]) {
        return MenuCAReport.filter(function (number) {
            return AccessFoCA.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu FA
    getMenuFASetup(AccessFoFA: string[]) {
        return MenuFASetup.filter(function (number) {
            return AccessFoFA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuFAInput(AccessFoFA: string[]) {
        return MenuFAInput.filter(function (number) {
            return AccessFoFA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuFAProcess(AccessFoFA: string[]) {
        return MenuFAProcess.filter(function (number) {
            return AccessFoFA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuFAInquiry(AccessFoFA: string[]) {
        return MenuFAInquiry.filter(function (number) {
            return AccessFoFA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuFAReport(AccessFoFA: string[]) {
        return MenuFAReport.filter(function (number) {
            return AccessFoFA.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu IN
    getMenuINSetup(AccessFoIN: string[]) {
        return MenuINSetup.filter(function (number) {
            return AccessFoIN.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuINInput(AccessFoIN: string[]) {
        return MenuINInput.filter(function (number) {
            return AccessFoIN.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuINProcess(AccessFoIN: string[]) {
        return MenuINProcess.filter(function (number) {
            return AccessFoIN.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuINReport(AccessFoIN: string[]) {
        return MenuINReport.filter(function (number) {
            return AccessFoIN.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu SA
    getMenuSASetup(AccessFoSA: string[]) {
        return MenuSASetup.filter(function (number) {
            return AccessFoSA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSAInput(AccessFoSA: string[]) {
        return MenuSAInput.filter(function (number) {
            return AccessFoSA.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSAReport(AccessFoSA: string[]) {
        return MenuSAReport.filter(function (number) {
            return AccessFoSA.indexOf(number.RouterLink) > -1;
        });
    }


    // Get Menu PO
    getMenuPOInput(AccessFoPO: string[]) {
        return MenuPOInput.filter(function (number) {
            return AccessFoPO.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuPOProcess(AccessFoPO: string[]) {
        return MenuPOProcess.filter(function (number) {
            return AccessFoPO.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuPOReport(AccessFoPO: string[]) {
        return MenuPOReport.filter(function (number) {
            return AccessFoPO.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu SO
    getMenuSOInput(AccessFoSO: string[]) {
        return MenuSOInput.filter(function (number) {
            return AccessFoSO.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSOProcess(AccessFoSO: string[]) {
        return MenuSOProcess.filter(function (number) {
            return AccessFoSO.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSOReport(AccessFoSO: string[]) {
        return MenuSOReport.filter(function (number) {
            return AccessFoSO.indexOf(number.RouterLink) > -1;
        });
    }
    // Get Menu EInvoice
    getMenuEIInput(AccessFoEI: string[]) {
        return MenuEIInput.filter(function (number) {
            return AccessFoEI.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuEIProcess(AccessFoEI: string[]) {
        return MenuEIProcess.filter(function (number) {
            return AccessFoEI.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuEISetup(AccessFoEI: string[]) {
        return MenuEISetup.filter(function (number) {
            return AccessFoEI.indexOf(number.RouterLink) > -1;
        });
    }
    // Get Menu SI
    getMenuSIInput(AccessFoSI: string[]) {
        return MenuSIInput.filter(function (number) {
            return AccessFoSI.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu UF
    getMenuUFInput(AccessFoUF: string[]) {
        return MenuUFInput.filter(function (number) {
            return AccessFoUF.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu ST
    getMenuSTInput(AccessFoST: string[]) {
        return MenuSTSetup.filter(function (number) {
            return AccessFoST.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSTSecurity(AccessFoST: string[]) {
        return MenuSTSecurity.filter(function (number) {
            return AccessFoST.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu BG
    getMenuBGInput(AccessFoBG: string[]) {
        return MenuBGInput.filter(function (number) {
            return AccessFoBG.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuBGReport(AccessFoBG: string[]) {
        return MenuBGReport.filter(function (number) {
            return AccessFoBG.indexOf(number.RouterLink) > -1;
        });
    }

    // Get Menu SP
    getMenuSPInput(AccessFoSP: string[]) {
        return MenuSPInput.filter(function (number) {
            return AccessFoSP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSPReport(AccessFoSP: string[]) {
        return MenuSPReport.filter(function (number) {
            return AccessFoSP.indexOf(number.RouterLink) > -1;
        });
    }
    // Get Menu CP
    getMenuCPFinancialStatement(AccessFoCP: string[]) {
        return MenuCPFinancialStatement.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPCustomers(AccessFoCP: string[]) {
        return MenuCPCustomers.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPVendors(AccessFoCP: string[]) {
        return MenuCPVendors.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPRevenues(AccessFoCP: string[]) {
        return MenuCPRevenues.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPCost(AccessFoCP: string[]) {
        return MenuCPCost.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPAnalyze(AccessFoCP: string[]) {
        return MenuCPAnalyze.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPManagements(AccessFoCP: string[]) {
        return MenuCPManagements.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuCPHumanResources(AccessFoCP: string[]) {
        return MenuCPHumanResources.filter(function (number) {
            return AccessFoCP.indexOf(number.RouterLink) > -1;
        });
    }
}
